export interface ErrorMapping {
  ftlId: string;
  vars?: Record<string, string | number>;
}

const bytesToWholeMB = (bytes: number): number =>
  Math.round(bytes / (1024 * 1024));

export const pickErrorMapping = (
  backendCode: string | undefined,
  maxSizeBytes: number
): ErrorMapping => {
  switch (backendCode) {
    case "file_too_large":
      return {
        ftlId: "receipts-upload-error-size",
        vars: { sizeMb: bytesToWholeMB(maxSizeBytes) },
      };
    case "unsupported_mime_type":
      return { ftlId: "receipts-upload-error-type" };
    case "corrupt_file":
      return { ftlId: "receipts-upload-error-integrity" };
    default:
      return { ftlId: "receipts-upload-error-generic" };
  }
};

type UploadRowErrorDetails = {
  fileName: string;
  maxSizeBytes: number;
  retryAfterSeconds?: number;
};

const fileExtension = (fileName: string): string | undefined => {
  const dot = fileName.lastIndexOf(".");
  if (dot <= 0 || dot === fileName.length - 1) return undefined;
  return fileName.slice(dot + 1).toLowerCase();
};

const SECONDS_PER_MINUTE = 60;

export const pickUploadRowError = (
  errorCode: string | undefined,
  { fileName, maxSizeBytes, retryAfterSeconds }: UploadRowErrorDetails
): ErrorMapping => {
  switch (errorCode) {
    case "file_too_large":
      return {
        ftlId: "receipts-upload-row-error-size",
        vars: { sizeMb: bytesToWholeMB(maxSizeBytes) },
      };
    case "unsupported_mime_type": {
      const extension = fileExtension(fileName);
      return extension
        ? { ftlId: "receipts-upload-row-error-type", vars: { extension } }
        : { ftlId: "receipts-upload-row-error-type-unknown" };
    }
    case "corrupt_file":
      return { ftlId: "receipts-upload-error-integrity" };
    case "throttled":
      return {
        ftlId: "receipts-upload-row-error-limit",
        vars: {
          minutes: Math.max(
            1,
            Math.ceil((retryAfterSeconds ?? 0) / SECONDS_PER_MINUTE)
          ),
        },
      };
    default:
      return { ftlId: "receipts-upload-row-error-failed" };
  }
};
